/**
 * This file is used to render the HVA Widget
 * @see configuration/webpack.config.js
 */

import React from "react";
import ReactDOM from "react-dom";
import { KatSpinner } from "@amzn/katal-react";

// Uncomment these lines to include PUI

// require('./_pui-assets/bundle.js');
// require('./_pui-assets/webcomponents-loader.js');

import "@amzn/katal-components/styles.css";
import { HvaWidget, RefLaunchPage } from "@amzn/robin_web_app_components";

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback={<KatSpinner size="large" />}>
      <HvaWidget launchPage={RefLaunchPage.None} />
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById("react-root-hvaWidget")
);
